export default {
  documentation_link: "https://payments.paypack.rw/api",
  github_link: "https://github.com/quarksgroup/paypack-engine",
  twitter_link: "https://twitter.com/paypack_rw/",
  instagram_link: "https://www.instagram.com/paypack_rw/",
};
